import React from "react";
import ColorButtons from "../atoms/ColorButtons";
import { useBoundStore } from "../../stores/useBoundStore";
import styled from "styled-components";

const ColorInputs = styled.div`
  height: auto;
  width: 100%;
  ${(props) => props.theme.fluidType(-1)};

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

const TextBackgroundColorControls = () => {
  const { setTextBGColor, textBGActive, setTextBGActive } = useBoundStore(
    (state) => state
  );

  const handleTextChange = (val, color) => {
    setTextBGColor(color);
  };

  const handleCheckbox = (e) => {
    setTextBGActive(e.target.checked);
  };

  return (
    <ColorInputs>
      <header>
        <p className="label">Text BG</p>
        <input
          type="checkbox"
          checked={textBGActive}
          onChange={handleCheckbox}
        />
      </header>
      <ColorButtons textColor={true} clickHandler={handleTextChange} />
    </ColorInputs>
  );
};

export default TextBackgroundColorControls;
